import { useQuery } from "@tanstack/react-query"
import { profile } from  '@shared/api/services'

export const useOnboardNeeded = ({options}) => {
	return  useQuery({
		queryKey: ['onboard-needed'], 
		queryFn: () => profile.getOnboardNeeded(), 
		select: (data) => data.data,
		retry: 3,
		...options
	})
}